import React, { useEffect } from 'react';
import { IScenarioItem } from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import ScenariosPg from './ScenariosPg';
import { fetchSceneriosList } from '../Store/GetDropDownsValuesReducer';

interface RootState {  
  scenariosList: {  
    scenariosList: IScenarioItem[];  
    loading: boolean;  
  };  
}  

function Scenarios({ setTabIndex }: { setTabIndex: any }) {
  const { scenariosList, loading } = useSelector((state: RootState) => state.scenariosList);  
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchSceneriosList());
  }, []);

  if (loading) {  
    return (  
      <div className="contentDiv">  
        <h3>Loading...</h3>  
      </div>  
    );  
  }  
  
  if (!scenariosList) {  
    return <h3>Data not found...</h3>;  
  }  
  return (
    <>
      <ScenariosPg scenariosLists={scenariosList} setTabIndex={setTabIndex} />
    </>
  );
}

export default Scenarios;
